<template>
  <div
    v-if="bonoActual"
    :class="`w-full bg-bono-${bono} ie11_only safari_only bg-no-repeat bg-cover mb-3`"
  >
    <nav
      class="relative flex flex-wrap items-center justify-between h-20 pt-8 md:pt-2"
    >
      <div
        class="flex items-center flex-shrink-0 w-48 max-w-sm pl-2 mr-6 text-white md:w-full"
      >
        <router-link :to="`/${$i18n.locale}/`">
          <img class="w-full" :src="bonoActual.banner" alt="logo" />
        </router-link>
      </div>
      <div class="block pr-2 lg:hidden">
        <button
          @click="menu = !menu"
          class="flex items-center px-3 py-2 text-white border-gray-400 rounded hover:font-semibold hover:border-gray-500"
        >
          <svg
            class="w-3 h-3 fill-current"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
          >
            <title>Menu</title>
            <path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z" />
          </svg>
        </button>
      </div>
      <div
        class="items-center hidden pt-3 text-sm font-light lg:flex lg:flex-grow"
      >
        <div class="text-sm font-light lg:flex-grow">
          <router-link
            :to="`/${$i18n.locale}/`"
            class="block mt-4 mr-4 text-white lg:inline-block lg:mt-0 hover:font-semibold"
          >
            {{ $t("Inicio") }}
          </router-link>
          <router-link
            v-if="$t('activar_altas') == 'S'"
            :to="`/${$i18n.locale}/altas`"
            class="block mt-4 mr-4 text-white lg:inline-block lg:mt-0 hover:font-semibold"
          >
            {{ $t("Alta comercios") }}
          </router-link>
          <router-link
            :to="`/${$i18n.locale}/contenido/condiciones`"
            class="block mt-4 mr-4 text-white lg:inline-block lg:mt-0 hover:font-semibold"
          >
            {{ $t("Leer condiciones") }}
          </router-link>
        </div>

        <div>
          <router-link
            :to="`/${$i18n.locale}/establecimientos`"
            :class="`inline-block text-sm px-2 py-1 leading-none border rounded-full bg-white text-bono-${bono} border-gray-200 hover:border-transparent hover:font-semibold hover:bg-white mt-4 lg:mt-0`"
            >{{ $t("Comprar bonos") }}</router-link
          >
        </div>
      </div>
      <div
        v-if="menu"
        :class="`lg:hidden w-full block flex-grow  relative z-10 px-2 pb-2 bg-bono-${bono}`"
      >
        <div class="text-sm font-light lg:flex-grow">
          <router-link
            :to="`/${$i18n.locale}/`"
            class="block mt-4 mr-4 text-white lg:inline-block lg:mt-0 hover:font-semibold"
          >
            {{ $t("Inicio") }}
          </router-link>
          <router-link
            v-if="$t('activar_altas') == 'S'"
            :to="`/${$i18n.locale}/altas`"
            class="block mt-4 mr-4 text-white lg:inline-block lg:mt-0 hover:font-semibold"
          >
            {{ $t("Alta comercios") }}
          </router-link>
          <router-link
            :to="`/${$i18n.locale}/contenido/condiciones`"
            class="block mt-4 mr-4 text-white lg:inline-block lg:mt-0 hover:font-semibold"
          >
            {{ $t("Leer condiciones") }}
          </router-link>
        </div>
        <div>
          <router-link
            :to="`/${$i18n.locale}/establecimientos`"
            :class="`inline-block text-sm px-4 py-2 leading-none border rounded bg-bono-${bono} text-white border-gray-200 hover:border-transparent hover:text-color-accent hover:font-semibold hover:bg-white mt-4 lg:mt-0`"
            >{{ $t("Comprar bonos") }}</router-link
          >
        </div>
      </div>
    </nav>
    <div class="relative px-5 pt-2">
      <button
        @click="$router.go(-1)"
        class="absolute mt-2 text-xs text-gray-400 hover:text-blue-600"
      >
        <svg
          class="w-5 h-5 fill-current"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
        >
          <path
            d="M10 20a10 10 0 1 1 0-20 10 10 0 0 1 0 20zm8-10a8 8 0 1 0-16 0 8 8 0 0 0 16 0zM7.46 9.3L11 5.75l1.41 1.41L9.6 10l2.82 2.83L11 14.24 6.76 10l.7-.7z"
          />
        </svg>
      </button>
    </div>
  </div>
</template>
<script>
export default {
  mounted() {
    this.menu = false;
    this.$store.dispatch("getBono", "bizkaia");
  },
  computed: {
    bonoActual() {
      return this.$store.state.bonoActual;
    },
    bono() {
      const bono = this.$store.state.bonoName;
      //   if (!bono || bono == "home") {
      //     this.$router.push(`/${this.$i18n.locale}/`);
      //   }

      return bono;
    },
    menu: {
      get() {
        return this.$store.state.menu;
      },
      set(valor) {
        this.$store.commit("menu", valor);
      },
    },
  },
};
</script>
<style>
@media screen and (-ms-high-contrast: active),
  screen and (-ms-high-contrast: none) {
  /* IE10+ specific styles go here */
  .ie11_only {
    background-color: #7d0451;
  }
}
@media screen and (min-color-index: 0) and(-webkit-min-device-pixel-ratio:0) {
  @media {
    .safari_only {
      background-color: #7d0451;
    }
  }
}
</style>